import { useState } from 'react';
import moment from 'moment';
import { sendRequest } from '../../hooks/requests/useRequest';

export const useReportStudiesPatient = () => {

    const [formValues, setFormValues] = useState({
        start_date: "",
        end_date: "",
        id_patient: 0,

    });

    const [searchPatientState, setSearchPatientState] = useState("");
    const [tableData, setTableData] = useState(null);
    const [search, setSearch] = useState("");
    const [studies, setStudies] = useState([]);
    const [selectedStudy, setSelectedStudy] = useState([]);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isPatientSelected, setIsPatientSelected] = useState(true);

    const [isDownloadComplete, setIsDownloadComplete] = useState(false);
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [showStudyHint, setShowStudyHint] = useState(false);
    const [hasShownStudy, setHasShownStudy] = useState(false);
    const [searchKey, setSearchKey] = useState(0);
    const { start_date, end_date, id_patient } = formValues;

    const handleInputChange = (e) => {
        if (!e?.target) return;

        const { name, value } = e.target;

        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === "start_date" || name === "end_date") {
        resetStudies();
    }
    };

    

    const resetStudies = () => {
        setStudies([]);
        setSelectedStudy([]);
        setShowStudyHint(false); 
    };
    
    const handleSelectChange = (option) => {
        const id =
            option?.target?.value ??
            option?.value ??
            option?.id_patient ??
            option?.id ??
            0;

        setFormValues(prev => ({
            ...prev,
            id_patient: id
        }));
        resetStudies();
    };

    const DownloadReportStudiesPatient = async () => {

        let _token = localStorage.getItem("token");

        let params = new URLSearchParams();

        if (start_date) {
            params.append("start", moment(start_date).format("YYYY-MM-DD"));
        }

        if (end_date) {
            params.append("end", moment(end_date).format("YYYY-MM-DD"));
        }

        const url = `/api/Reports/ExportResultsExamsPatient/${id_patient}?${params.toString()}`;

        await fetch(url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + _token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => response.blob())
            .then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", "Reporte_historico_paciente.xlsx");
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(fileURL);
            });
    };

    const GetReportStudiesPatientJson = async () => {

        let params = new URLSearchParams();

        if (start_date) {
            params.append("start", moment(start_date).format("YYYY-MM-DD"));
        }

        if (end_date) {
            params.append("end", moment(end_date).format("YYYY-MM-DD"));
        }

        const endpoint = `Reports/ExportResultsExamsPatientJson/${id_patient}?${params.toString()}`;

        const response = await sendRequest("GET", endpoint, "Resultados del paciente");

        return response;
    };
    



    const handleLoadTable = async () => {

        if (!id_patient || id_patient === 0) {
            setIsPatientSelected(false);
            return;
        }

        setIsPatientSelected(true);
        setIsLoadingTable(true); 
        try {
            const data = await GetReportStudiesPatientJson();
            console.log("🍿 data", data);

            if (!data?.data) return;

            setTableData(data);

            const studiesList = [];

            const exams = data?.data?.exams ?? [];

            exams.forEach(exam => {
                if (exam.exam) {
                    studiesList.push({
                        label: exam.exam,
                        value: `exam||${exam.exam}`
                    });
                }
            });
           const uniqueStudies = Array.from(
                new Map(studiesList.map(item => [item.value, item])).values()
            );

            if (uniqueStudies.length === 0) {
                setStudies([
                    { label: "Sin estudios encontrados", value: "EMPTY" }
                ]);
            } else {
                setStudies([
                    ...uniqueStudies
                ]);
            }

            console.log("STUDIES LIST:", studiesList);
            console.log("UNIQUE:", uniqueStudies);

            if (!hasShownStudy) {
                setShowStudyHint(true);
                setHasShownStudy(true);

                setTimeout(() => {
                    setShowStudyHint(false);
                }, 2500);
            }

            setSelectedStudy([]);

        } finally {
            setIsLoadingTable(false); 
        }
    };
    

    const handleSearch = (e) => {
        setSearch(e.target.value.toLowerCase());
    };


    //#region VALIDATIONS
     const handleDownloadClick = async () => {

        console.log("🧪 ID ACTUAL:", id_patient);

        let valid = true;

        if (!id_patient || id_patient === 0) {
            setIsPatientSelected(false);
            valid = false;
        } else {
            setIsPatientSelected(true);
        }

        // if (!start_date) {
        //     setIsStartDateValid(false);
        //     valid = false;
        // } else {
        //     setIsStartDateValid(true);
        // }

        // if (!end_date) {
        //     setIsEndDateValid(false);
        //     valid = false;
        // } else {
        //     setIsEndDateValid(true);
        // }

        if (!valid) return;

        setIsButtonDisabled(true);
        setIsDownloading(true);
        setIsDownloadComplete(false);

        await DownloadReportStudiesPatient(id_patient);

        setIsDownloading(false);
        setIsDownloadComplete(true);

        setTimeout(() => {
            setIsDownloadComplete(false);
            setIsButtonDisabled(false);
        }, 95000);
    };
    //#endregion

    const transformData = (data, selectedStudy) => {
        if (!data?.exams) return [];

        if (selectedStudy === "ALL") selectedStudy = null;

        const rows = [];

        const workOrderMap = {};
        data.work_orders.forEach(w => {
            workOrderMap[w.id_work_order] = w.nim;
        });

        data.exams.forEach(exam => {

            if (Array.isArray(selectedStudy) && selectedStudy.length > 0 && !selectedStudy.includes("ALL")) {
                const selectedExams = selectedStudy
                    .filter(s => s.startsWith("exam||"))
                    .map(s => s.split("||")[1]);

                if (!selectedExams.includes(exam.exam)) return;
            }

            exam.analytes.forEach(analyte => {

                const row = {
                    perfil: exam.exam,
                    examen: exam.exam,
                    analito: analyte.analyte,
                    cambios: analyte.has_changes ? "SI" : "NO",
                    isMicro: false
                };

                analyte.results.forEach(result => {
                    const nim = workOrderMap[result.id_work_order];
                    row[nim] = result.result ?? "-";
                });

                rows.push(row);
            });

            

           if (exam.antibiograms?.length > 0) {

                
                rows.push({
                    perfil: exam.exam,
                    examen: exam.exam,
                    analito: "MICROORGANISMOS",
                    cambios: "",
                    isMicro: true,
                    isTitle: true
                });

                const row = {
                    perfil: exam.exam,
                    examen: exam.exam,
                    analito: "", 
                    cambios: "NO",
                    isMicro: true,
                    isTitle: false
                };


                const tempValues = {};

                exam.antibiograms.forEach(ant => {

                    const nim = workOrderMap[ant.id_work_order];

                    const bacteriums = ant.bacteriums ?? [];

                    const values = bacteriums.map(b => ({
                        nombre: b.label_mic_bacterium || "-",
                        cantidad_num: b.quantity_number || "-",
                        cantidad_txt: b.label_bacterium_count_text || "-",
                        gram: b.label_mic_stain_gram || "-",
                        comment: b.comment_resistance_mechanism || "-"
                    }));

                    tempValues[nim] = values.length > 0 ? values : [];
                });

                const maxItems = Math.max(
                    ...Object.values(tempValues).map(v => v.length),
                    1
                );

                Object.entries(tempValues).forEach(([nim, values]) => {

                    const normalized = [...values];

                    while (normalized.length < maxItems) {
                        normalized.push(null);
                    }

                    row[nim] = normalized;
                });

                row.maxItems = maxItems;

                rows.push(row);
            }
        });

        return rows;
    };

    

    const hasSelectedStudy = Array.isArray(selectedStudy) && selectedStudy.length > 0;

    const rows = tableData?.data && hasSelectedStudy
        ? transformData(tableData.data, selectedStudy)
        : [];


    const groupData = (rows) => {
        const map = {};

        rows.forEach(row => {
            if (!map[row.perfil]) {
                map[row.perfil] = [];
            }
            map[row.perfil].push(row);
        });

        return map;
    };

    const filteredRows = rows.filter(row => {
        const text = search.toLowerCase();

        return (
            row.perfil?.toLowerCase().includes(text) ||
            row.examen?.toLowerCase().includes(text) ||
            row.analito?.toLowerCase().includes(text) ||
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(text)
            )
        );
    });
    
    const grouped = groupData(filteredRows);

    
    const totalPerfiles = new Set(
        filteredRows
            .map(r => r.perfil)
            .filter(p => p && p !== "SIN PERFIL")
    ).size;
    const totalExamenes = new Set(filteredRows.map(r => r.examen)).size;

    const totalAnalitos = new Set(
        filteredRows
            .map(r => r.analito)
            .filter(a => a && a.trim() !== "")
    ).size;

    const totalCambios = filteredRows.filter(r => r.cambios === "SI").length;

    const totalNims = tableData?.data?.work_orders?.length || 0;

   const handleClearAll = () => {

        setFormValues({
            start_date: "",
            end_date: "",
            id_patient: 0,
        });

        setSearchPatientState("");

        setStudies([]);
        setSelectedStudy([]);

        setTableData(null);

        setIsPatientSelected(true);
        setShowStudyHint(false);

    };
    


    return {
        handleInputChange,
        handleSelectChange,
        DownloadReportStudiesPatient,
        start_date,
        end_date,
        id_patient,
        searchPatientState,
        setSearchPatientState,
        GetReportStudiesPatientJson,
        tableData,
        handleLoadTable,
        handleSearch, search,
        selectedStudy, studies, setSelectedStudy,


        setIsButtonDisabled, isButtonDisabled,
        setIsDownloading, isDownloading, isPatientSelected,
        setIsPatientSelected, isDownloadComplete, setIsDownloadComplete,
        handleDownloadClick,
        filteredRows, grouped,
        totalPerfiles, totalExamenes, totalAnalitos, totalCambios, rows,
        isLoadingTable,showStudyHint,
        resetStudies, handleClearAll,
        searchKey, setSearchKey, totalNims
    };
};

